<template>
<w-setting-sliding-popup ref="slidingPopup" :title="popupTitle" width="500px" @close="close" @open="open">
  <div slot="content">
    <div class="title-h4 title-bar">기본정보</div>
    <div class="list form-list mr-b25">
      <el-form ref="basicInfoForm" :model="basicInfoFormData" label-width="120px">
        <el-form-item label="이름">
          <w-text-form :modifiable="false" :target="basicInfoFormData" property="credentialName">
          </w-text-form>
        </el-form-item>
        <el-form-item label="방식">
          <w-text-form :modifiable="false" :target="basicInfoFormData" property="credentialMethodId">
          </w-text-form>
        </el-form-item>
        <el-form-item label="설명">
          <w-text-form :modifiable="false" :target="basicInfoFormData" property="credentialDesc">
          </w-text-form>
        </el-form-item>
      </el-form>
    </div>
    <div class="title-h4 title-bar">접속방식 설정</div>
    <div class="list form-list">
      <el-form ref="connectionInfoForm" :model="connectionInfoFormData" label-width="120px">
        <el-form-item label="프로토콜">
          <w-text-form :modifiable="false" :target="connectionInfoFormData" property="credentialTypeId">
          </w-text-form>
        </el-form-item>
        <el-form-item label="포트">
          <w-text-form :modifiable="false" :target="connectionInfoFormData" property="telnetPort">
          </w-text-form>
        </el-form-item>
        <el-form-item label="1차 로그인 계정">
          <w-text-form :modifiable="false" :target="connectionInfoFormData" property="loginId">
          </w-text-form>
        </el-form-item>
        <el-form-item label="1차 로그인 비밀번호">
          <w-text-form :modifiable="false" type="password" :target="connectionInfoFormData" property="loginPassword">
          </w-text-form>
        </el-form-item>
        <el-form-item label="2차 로그인 계정">
          <w-text-form :modifiable="false" :target="connectionInfoFormData" property="privilegeId">
          </w-text-form>
        </el-form-item>
        <el-form-item label="2차 로그인 비밀번호">
          <w-text-form :modifiable="false" type="password" :target="connectionInfoFormData" property="privilegePassword">
          </w-text-form>
        </el-form-item>
        <el-form-item label="로그인 템플릿">
          <w-text-form :modifiable="false" :target="connectionInfoFormData" property="templateName">
          </w-text-form>
        </el-form-item>
      </el-form>
    </div>
  </div>
  <div slot="footer">
    <el-button size="large" @click="clickCloseButton">닫기</el-button>
  </div>
</w-setting-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import WTextForm from '@/components/formeditor/TextFormEditor';

export default {
  name: 'WCredentialInfoPopup',
  components: {
    WTextForm,
  },
  props: {
    selectedBasicInfoFormData: Object,
    selectedSubFormData: Object,
  },
  watch: {
    selectedBasicInfoFormData(object) {
      if (!isNil(object)) {
        this.popupTitle = `${object.credentialName} 정보`;
        this.basicInfoFormData = object;
        this.selectedSubFormData.attrTypeId = object.credentialTypeId;
        Object.assign(this.connectionInfoFormData, this.selectedSubFormData);
      }
    },
  },
  data() {
    return {
      popupTitle: null,
      basicInfoFormData: {
        credentialMethodId: 'SCAN',
      },
      connectionInfoFormData: {
        templateId: null,
        attrTypeId: 'TELNET',
        telnetPort: 23,
        sshPort: 22,
      },
    };
  },
  methods: {
    loadData() {},
    open() {
    },
    close() {
      this.$emit('close-popup');
      this.$refs.basicInfoForm.resetFields();
      this.$refs.connectionInfoForm.resetFields();
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    clickCloseButton() {
      this.closePopup();
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/popup/CredentialInfoPopup.vue